import type { LE } from "@/constants/enums";
import type { ContainerMaterialTypeRadioOption, Distributor, DistributorNew } from "@/views/distributor/distributor";
import { murnAddressFromFormkit, murnAddressToFormkit } from "@modernary/mui/components/fk";
import { fillPrefixedAddressLookupValues, getLookupsFromLookupGroup } from "@modernary/mui/components/lookup";
import { getUniqueId } from "@modernary/mui/utils/helpers";
import type { Ref } from "vue";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Distributor) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData() {
  const result = {} as Distributor; //TODO: ts
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Distributor }) {
  addAuthRequestFields(response.data);

  return response.data;
}

/** Be sure to await this when using it.  */
async function responseAdapter(response: { data: Distributor }) {
  await skinnyResponseAdapter(response);
  await fillPrefixedAddressLookupValues(response.data, ["mail"]);

  return response.data;
}

function requestAdapter(data: Distributor, materialTypeRadioOptions?: ContainerMaterialTypeRadioOption[]) {
  const containerMaterialTypes: LE.ContainerMaterialType[] = [];

  // TODO: This was already being handled in here, but consider putting it in the "fromFormkit" function instead.
  if (materialTypeRadioOptions?.length && data._containerMaterialTypeRadios) {
    for (const opt of materialTypeRadioOptions) {
      if (data._containerMaterialTypeRadios[opt.name] === true) {
        containerMaterialTypes.push(opt.yesMurn);
      }
    }
  }

  data.containerMaterialTypeMurns = containerMaterialTypes;
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
async function toFormkit<T extends Distributor | DistributorNew>(
  data: T,
  optionsList?: Ref<ContainerMaterialTypeRadioOption[]>,
) {
  if (optionsList) {
    getLookupsFromLookupGroup("ContainerMaterialType").then((result) => {
      if (!result) return;
      const containerMaterialTypeOptions: ContainerMaterialTypeRadioOption[] = [];
      result._items.forEach((x) => {
        let containerOption: ContainerMaterialTypeRadioOption = {
          label: x.description,
          name: getUniqueId(`_matType`),
          yesMurn: x.murn as LE.ContainerMaterialType,
        };
        containerMaterialTypeOptions.push(containerOption);
      });
      optionsList.value = containerMaterialTypeOptions;

      if (data.containerMaterialTypeMurns) {
        containerMaterialTypeOptions.forEach((option) => {
          const hasMatch = data.containerMaterialTypeMurns?.includes(option.yesMurn) === true; // This is intentional to get true/false rather than true/false/undefined.
          if (!data._containerMaterialTypeRadios) data._containerMaterialTypeRadios = {};
          data._containerMaterialTypeRadios[`${option.name}`] = hasMatch;
        });
      }
    });
  }
  murnAddressToFormkit(data, "mail");
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Distributor) {
  murnAddressFromFormkit(data, "mail");
}
